import { twMerge } from "tailwind-merge";

export const inputClasses =
  "mt-2 h-14 rounded border-green-tea bg-child-of-light pt-8 text-[15px]";
export const inputErrorClasses = twMerge(
  inputClasses,
  "border-validation-red bg-white text-validation-red text-[15px]",
);

export const labelClasses =
  "absolute ml-3 mt-[14px] text-[15px] font-normal text-grey-blue";
export const errorIconClasses =
  "absolute right-[14px] top-[28px] text-validation-red";

export const cancelBtnClasses =
  "mt-1 flex justify-self-end rounded-xl bg-white px-4 py-2 text-base text-deep-blue";
export const btnClasses =
  "mt-1 flex justify-self-end rounded-xl bg-teal-700 px-4 py-2 text-base text-clear-sky";
export const btnIconClasses = "mr-4 mt-[3px] text-clear-sky";
